import React,{ useState, useEffect } from "react";
import { 
    Card,
    Button
} from 'antd';

import { 
    FrownOutlined
} from '@ant-design/icons';

function NoServices( { isFibreComponent } ) {
    const [noServicesHeader, setNoServicesHeader] = useState( '' );
    const [noServicesCopy, setNoServicesCopy] = useState( '' );

    useEffect(() => {
        console.log('isFibreComponent:: ', isFibreComponent);

        if( isFibreComponent ) {
            setNoServicesHeader(
            <div className="no-services-header">
                <FrownOutlined
                    style={{
                        color: '#414042',
                        fontSize:'3rem',
                        display:'block'
                    }}
                />
                <span>
                    Unfortunately, we could not find any Fibre services available for that address.
                </span>
            </div>);
            
            setNoServicesCopy(
                <>
                    <p>You can still get reliable, speedy, and budget-friendly cable internet with Start.ca. Check to see which internet plans are right for you.</p>
                    <h4>Outside of Ontario?</h4>
                    <p style={{ maxWidth:'435px', margin:'0 auto' }}>Check out our sibling-company <a href="https://www.koodomobile.com/en/shop/subscriptions/internet" style={{ fontWeight:700 }} target="_blank">Koodo Internet</a> for internet package availability!</p>
                    <Button 
                        type="primary" 
                        style={{ backgroundColor:'#1C4A12', marginTop: '1rem' }}
                        class="internet-package-check-availability-button"
                        onClick={ () => window.location.href = '/services/high-speed-internet#internet-packages-content-section' }>
                        View Internet Plans
                    </Button>
                </>
            );
        } else {
            setNoServicesHeader(<></>);
            setNoServicesCopy(<></>);
            //setNoServicesHeader(<div className="no-services-header">Unfortunately, we could not find any services available for that address.</div>);

            /*setNoServicesCopy(
                <>
                    <p>If you need assistance please contact us and we’d be happy to help.</p>
                    <h4>Outside of Ontario?</h4>
                    <p style={{ maxWidth:'435px', margin:'0 auto' }}>Check out our sibling-company <a href="https://www.koodomobile.com/en/shop/subscriptions/internet" style={{ fontWeight:700 }} target="_blank">Koodo Internet</a> for internet package availability!</p>
                    <Button 
                        type="primary" 
                        style={{ backgroundColor:'#1C4A12', marginTop: '1rem' }}
                        class="internet-package-check-availability-button"
                        onClick={ handleCheckAvailability }>
                        Try another address
                    </Button>
                </>
            );*/
        }
    },[ isFibreComponent ]);

    const handleCheckAvailability = ( e ) => {
        let checkAvailabilityBtn = jQuery(".check-availability-btn .elementor-button, .internet-package-check-availability-button");
        let checkAvailabilityOverlay = jQuery(".modal-overlay");
        let addressInput = jQuery("#check-availability-modal-address-input");
        checkAvailabilityOverlay.toggleClass("active");
    }

    return(
        <div className="no-services-available-content-container">
            { noServicesHeader }
            { noServicesCopy }
        </div>
    )
}

export default NoServices